import { ModelRouteKpiPanel } from './components/ModelRouteKpiPanel'
import { ModelRouteListView } from './components/ModelRouteListView'
import { useModelRouteList } from './hooks/useModelRouteList'

export function ModelRoutePage() {
  const listState = useModelRouteList()

  return (
    <div className="flex flex-col h-full">
      <ModelRouteKpiPanel />
      <div className="card bg-panel-white mt-2.5 h-full overflow-y-auto">
        <ModelRouteListView {...listState} />
      </div>
    </div>
  )
}
